import { render, staticRenderFns } from "./GeneralConfigComponent.vue?vue&type=template&id=b037d580&"
import script from "./GeneralConfigComponent.vue?vue&type=script&lang=js&"
export * from "./GeneralConfigComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports